import {
    LabelBody,
    LabelBodySmall,
    LabelDisplay2,
} from '../../modules/components';

import {
    ThermometerState0,
    ThermometerState1,
    ThermometerState2,
    ThermometerState3,
    ThermometerState4,
    ThermometerState5,
} from '../icons';

import { ThermometerButton } from '../components/ThermometerButton';

type ThermometerSelectorProps = {
    selected: number;
    onChange: (value: number) => void;
    title?: string;
    description?: string;
    showLogbookInfo?: boolean;
};

export function ThermometerSelector({
    selected,
    onChange,
    title = 'Hvor stresset føler du dig?',
    description = 'Brug et øjeblik på at tjekke ind. Det kan gøre det lettere at forstå, hvad der sker indeni – og hvad du har brug for.',
    showLogbookInfo = true,
}: ThermometerSelectorProps) {
    const images: Record<number, JSX.Element> = {
        0: <ThermometerState0 />,
        1: <ThermometerState1 />,
        2: <ThermometerState2 />,
        3: <ThermometerState3 />,
        4: <ThermometerState4 />,
        5: <ThermometerState5 />,
    };

    return (
        <>
            <LabelDisplay2 className="my-10">{title}</LabelDisplay2>

            <LabelBody className={`${showLogbookInfo ? 'mb-20' : 'mb-60'}`}>
                {description}
            </LabelBody>

            {showLogbookInfo && (
                <LabelBody className="mb-60">
                    Din temperaturmåling bliver gemt i logbogen når du
                    fortsætter.
                </LabelBody>
            )}

            <div className="flex">
                <div className="flex flex-1 justify-center">
                    {images[selected]}
                </div>

                <div className="flex flex-1 flex-col items-start">
                    <LabelBodySmall className="mb-20">
                        Mest stresset
                    </LabelBodySmall>

                    {[5, 4, 3, 2, 1].map((x) => (
                        <ThermometerButton
                            key={x}
                            className="mb-20"
                            isCentered={false}
                            onClick={() => onChange(x)}
                            selected={selected === x}
                        >
                            {x}
                        </ThermometerButton>
                    ))}

                    <LabelBodySmall>Mindst stresset</LabelBodySmall>
                </div>
            </div>
        </>
    );
}
